<template>
  <div class="Com_view">
    <div class="box_logo">
      <el-image :src="require('../assets/logo/logo_3.png')"></el-image>
    </div>
    <div class="box_contact">
      <span>联系方式：020-66672388 / 工作日时间：09:00-17:00</span>
    </div>
    <div class="box_footer">
      <a href="https://www.beian.gov.cn/">粤ICP备19031255号 Copyright © 1998-2020 Honesty Technology. All Rights Reserved. ©
        版权所有</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
    };
  },
  created() { },
  methods: {},
  mounted() { }
};
</script>
<style lang="less" scoped>
@media all and (max-width: 768px) {
  .Com_view {
    .box_footer {
      margin: 0 5% !important;
    }
  }
}
</style>
<style lang="less" scoped>
.Com_view {
  .box_logo {
    display: flex;
    justify-content: center;
    padding: 20px 0 5px 0;

    .el-image {
      width: 40%;
      min-width: 400px;
    }
  }

  .box_contact{
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin-bottom: 10px;
    span{
      margin: 0 10px;
      color: white;
      padding: 7px 15px;
      background: #67289C;
      border-radius: 50px;
      transform: scale(0.9);
      font-family: 黑体;
    }
  }

  .box_footer {
    text-align: center;
    font-size: 12px;
    margin-bottom: 20px;
    margin: 0 20%;
    padding: 20px 0;
    padding-top: 0;
    // border-top: 1px solid #4e346e2a;

    a:active {
      color: #4e346e;
    }
  }
}
</style>